import { useMemo } from "react";

import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { getProjectQueryDocument } from "./project.gql";

export interface UseGetProjectProps {
  id?: string;
  enabled?: boolean;
}

export const useGetProject = ({ id, enabled = true }: UseGetProjectProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.projects.detail(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Project ID is required");
      }

      const client = createOperationClient("GetProject");
      const data = await client.request(getProjectQueryDocument, {
        input: { id },
      });

      return data.project;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000, // 5 minutes for individual items
  });

  const project = useMemo(() => {
    return queryResult.data ?? null;
  }, [queryResult.data]);

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    project,
  };
};
